module.exports = __webpack_public_path__ + "img/pay_storing.d70f1563.png";